import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { host } from "config";
import { useState } from "react";
import isEmail from "validator/lib/isEmail";

export interface SaveAndResumeDialogProps {
  open: boolean;
  formNumber: string;
  strippedFormData: { [key: string]: any };
  onClose: () => void;
}

function SaveAndResumeDialog(props: SaveAndResumeDialogProps) {
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const { open, formNumber, strippedFormData, onClose } = props;

  const handleClose = () => {
    onClose();
  };
  const handleSubmit = () => {
    if (!isEmail(emailAddress)) {
      alert("Please enter a valid email address.");
      return;
    }
    const body = {
      User_Email: emailAddress,
      Submission_JSON: JSON.stringify(strippedFormData),
      Form_ID: formNumber,
    };
    fetch(`${host}/api/Reporting/FormSubmissions/savePartialSubmission`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          response.text().then((text) => {
            console.log("In not response ok");
            throw new Error(text);
          });
        } else {
          response.json().then(async (data: any) => {
            setIsLoading(false);

            handleClose();

            alert("Form saved successfully!");
          });
        }
      })
      .catch((error: any) => {
        console.error("Error:", error);
        alert(
          "There was an error while saving the form. Please try again later and contact IT if the problem persists."
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <CircularProgress />
      </div>
    );
  }

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
      <DialogTitle>Save and Resume Later</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Please enter your email below if you would like to save and resume later. Make sure it is correct as the link
          will be sent to this email, and will be used to verify the person submitting the form.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          variant="outlined"
          placeholder="Email address"
          value={emailAddress}
          onChange={(e) => setEmailAddress(e.target.value)}
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button onClick={handleClose}>Close</Button>
        <Button onClick={handleSubmit} variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SaveAndResumeDialog;
